type TodayAlertProps = {
  pending: number;
  onSelectToday: () => void;
};

export function TodayAlert({ pending, onSelectToday }: TodayAlertProps) {
  if (pending <= 0) {
    return <div className="cadence-today-alert is-empty">Nenhuma cadencia pendente para hoje.</div>;
  }

  return (
    <button className="cadence-today-alert" type="button" onClick={onSelectToday}>
      Hoje tem <strong>{pending}</strong> lead{pending === 1 ? "" : "s"} para cadencia.
    </button>
  );
}
